import React from "react";

type LoadingProps = {
  size?: number;
  color?: string;
  text?: string;
};

const Loading: React.FC<LoadingProps> = ({
  size = 32,
  color = "#19bbbb",
}) => {
  return (
    <div style={styles.wrapper}>
      <div
        style={{
          ...styles.spinner,
          width: size,
          height: size,
          borderColor: `${color}33`,
          borderTopColor: color,
        }}
      />

      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loading;

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    flex: 1,
  },
  spinner: {
    borderStyle: "solid",
    borderWidth: 3,
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  text: {
    fontSize: 14,
    fontWeight: 500,
  },
};
